import { css } from 'styled-components';
export var sharedStyles = css(["position:absolute;", " ", " right:-", "px;width:", "px;height:", "px;"], function (_ref) {
  var size = _ref.size,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom' : _ref$position;
  return position === 'top' ? "top: -".concat(size / 2 - size / 6, "px;") : '';
}, function (_ref2) {
  var size = _ref2.size,
    _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? 'bottom' : _ref2$position;
  return position === 'bottom' ? "bottom: -".concat(size / 2 - size / 6, "px;") : '';
}, function (_ref3) {
  var size = _ref3.size;
  return size / 2 - size / 6;
}, function (_ref4) {
  var size = _ref4.size;
  return size;
}, function (_ref5) {
  var size = _ref5.size;
  return size;
});